<template lang="pug">
div(v-if='forRemoval')
  .modal-content
    p.title.medium Remove Account
    .vspace.small
    p(v-if='account') Are you sure you want to {{ mutableAccount.status !== "active" ? "activate" : "deactivate" }}
      span.blue-text {{ " " + account.email }}?
    p This cannot be undone.
  .modal-footer.right-align
    a.waves-effect.btn.blue(
      v-if='mutableAccount.status !== "active"',
      @click='onRemove(mutableAccount)'
    ) Activate
    a.waves-effect.btn.red(
      v-if='mutableAccount.status === "active"',
      @click='onRemove(mutableAccount)'
    ) Deactivate
    a.waves-effect.btn-flat(@click='onCancel') Cancel
div(v-else)
  .modal-content
    p.title.medium(v-if='isNewAccount') New Account
    p.title.medium(v-else) Edit Account
    .vspace.small
    .row
      .col.s12.m6.input-field
        input#email.form-control.validate(
          v-model='mutableAccount.email',
          type='email',
          required
        )
        label.active(for='email') Email
      .col.s12.m6.input-field
        input#username.form-control.validate(
          v-model='mutableAccount.username',
          type='text',
          required,
          :readonly='!isNewAccount'
        )
        label.active(for='username') Username
      .col.s12.m6.input-field
        input#firstName.form-control.validate(
          v-model='mutableAccount.firstName',
          type='text',
          required
        )
        label.active(for='firstName') First Name
      .col.s12.m6.input-field
        input#lastName.form-control.validate(
          v-model='mutableAccount.lastName',
          type='text',
          required
        )
        label.active(for='lastName') Last Name
  .modal-footer.right-align
    a.waves-effect.btn.indigo(@click='onSave(mutableAccount, isNewAccount)') Save
    a.waves-effect.btn-flat(@click='onCancel') Cancel
  //- pre {{account}}
</template>
<script>
export default {
  props: [
    'account',
    'isNewAccount',
    'onSave',
    'onCancel',
    'forRemoval',
    'onRemove'
  ],
  data () {
    return {
      mutableAccount: {
        uid: null,
        email: null,
        username: null,
        firstName: null,
        lastName: null,
        supplierId: null,
        subSupplierId: null,
        status: null
      }
    }
  },
  mounted () {
    const account = this.account || {}
    this.mutableAccount.uid = account.uid
    this.mutableAccount.email = account.email
    this.mutableAccount.firstName = account.firstName
    this.mutableAccount.lastName = account.lastName
    this.mutableAccount.username = account.localMembership.username
    this.mutableAccount.supplierId = account.supplierId
    this.mutableAccount.subSupplierId = account.subSupplierId
    this.mutableAccount.status = account.status
  }
}
</script>



// WEBPACK FOOTER //
// src/components/app-acount-detail.vue